import './paged-list.scss';

export default {
  table: "table table-striped",
  pagination: "pagination-display",
  perPage: "per-page-dropdown form-inline",
  perPageLabel: "per-page-label",
  dropdown: "form-control",
  pagingControls: "paging-controls"
}
